class CartCount extends window.BAO.CustomElement() {
  setupListeners() {
    super.setupListeners();

    this.onCartChanged = this.onCartChanged.bind(this);
    this.onPageShow = this.onPageShow.bind(this);

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PUSH_CART.CHANGED,
      this.onCartChanged,
    );

    this.listeners.add(window, "pageshow", this.onPageShow);
  }

  /**
   * @param {CustomEvent} e
   *
   * @returns {void}
   */
  onCartChanged(e) {
    const { state } = e.detail;
    if (!state) return;
    if (!state.sections) return;

    if (!("push-cart-count" in state.sections)) return;

    this.textContent = this.getCount(state.sections["push-cart-count"]);
  }

  /**
   * @param {PageTransitionEvent} e
   *
   * @returns {Promise<void>}
   */
  async onPageShow(e) {
    if (!e.persisted) return;

    try {
      const response = await fetch("/cart.js");
      const cart = await response.json();
      this.textContent = cart.item_count;
    } catch (err) {
      console.error("CartCount: failed to refresh on pageshow", err);
    }
  }

  /**
   * @param {string} html
   *
   * @returns {string}
   */
  getCount(html) {
    const DOM = window.BAO.sectionRenderer.convertToDOM(html);

    return DOM.querySelector("#push-cart-count").textContent;
  }
}

if (!customElements.get("cart-count")) {
  customElements.define("cart-count", CartCount);
}
